import { render, staticRenderFns } from "./GoalDetails.vue?vue&type=template&id=8c26897e&scoped=true&"
import script from "./GoalDetails.vue?vue&type=script&lang=js&"
export * from "./GoalDetails.vue?vue&type=script&lang=js&"
import style0 from "./GoalDetails.vue?vue&type=style&index=0&id=8c26897e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c26897e",
  null
  
)

export default component.exports